import { createContext, useContext } from 'react';
import { ServicesMasterSchedule } from '../../../../app/athenaApiGen';

interface MppContextType {
  data: ServicesMasterSchedule[] | null;
  loading: boolean;
  error: Error | null;
  refreshData: () => Promise<void>;
  lastUpdated: Date | null;
  uploadInProgress: boolean;
  notifyUploadStart: () => void;
  notifyUploadComplete: () => Promise<void>;
}

export const MppContext = createContext<MppContextType>({
  data: null,
  loading: false,
  error: null,
  refreshData: async () => {},
  lastUpdated: null,
  uploadInProgress: false,
  notifyUploadStart: () => {},
  notifyUploadComplete: async () => {},
});

export const useMppContext = () => {
  const context = useContext(MppContext);
  if (!context) {
    throw new Error('useMppContext must be used within a MppContextProvider');
  }
  return context;
};
